export default "__VITE_ASSET__vam15Fyx__"